import { useState } from 'react';
import { Modal } from '../components/Modal';
import './AgeGatePopup.css';

export function AgeGatePopup({ onConfirm }) {
    const [rejected, setRejected] = useState(false);

    return (
        <Modal isOpen dismissible={false} size="sm" className="ageModal">
            <div className="ageBody">
                <span className="ageBadge">18+</span>
                {!rejected ? (
                    <>
                        <h2 className="modalTitle">You must be 18+</h2>
                        <p className="ageText">
                            This site contains explicit AI-generated adult content.
                            You must be <b>18 or older</b> to enter.
                        </p>
                        <div className="ageActions">
                            <button type="button" className="btn btn--primary btn--lg btn--block" onClick={onConfirm}>I&apos;m 18+ — Enter</button>
                            <button type="button" className="btn btn--ghost btn--block" onClick={() => setRejected(true)}>I&apos;m under 18</button>
                        </div>
                        <p className="ageFine">
                            By entering you confirm you are of legal age and that adult content is legal where you live.
                        </p>
                    </>
                ) : (
                    <>
                        <h2 className="modalTitle">Come back when you&apos;re older</h2>
                        <p className="ageText">You must be <b>18+</b> to access this site.</p>
                    </>
                )}
            </div>
        </Modal>
    );
}
